import { render, staticRenderFns } from "./FiltroResumoPropostasDashboard.vue?vue&type=template&id=6c3bf18c"
import script from "./FiltroResumoPropostasDashboard.vue?vue&type=script&lang=js"
export * from "./FiltroResumoPropostasDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports